<template>
    <div class="flex flex-col gap-4">
        <div
            v-if="image && image.path"
            class="aspect-[16/4] overflow-hidden rounded bg-gray-50"
        >
            <NuxtImg
                class="w-full overflow-hidden rounded object-center mix-blend-multiply"
                :class="!cloudflareImages ? 'h-full object-cover' : 'h-auto object-contain'"
                :src="image.path"
                loading="lazy"
                fit="cover"
                width="800"
                height="200" />
        </div>
        <div class="flex flex-col gap-2">
            <div class="flex items-center gap-2">
                <div class="flex items-center gap-2">
                    <Icon
                        v-if="isPopularCategory"
                        :icon="IconFire"
                        :auto-align="true"
                        class="text-xl text-amber-600" />
                    <h2 class="text-xl md:text-2xl/none">
                        {{ title }}
                    </h2>
                </div>
            </div>
        </div>
        <div v-if="description" class="flex flex-col gap-2">
            <p v-if="description" class="font-bold" v-html="description" />
        </div>
        <div class="flex flex-col gap-4">
            <template v-for="product in products">
                <Product v-if="product.available !== ProductAvailabilityOrderBuddy.NO_SHOW" :key="product.id" v-bind="product" />
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { CategoryOrderBuddy } from '~/types/orderbuddy-types'
    import IconFire from '@/assets/icons/fire.svg'
    import Icon from '~/components/Icon.vue'
    import Product from '~/components/Product/Product.vue'
    import { ProductAvailabilityOrderBuddy } from '~/types/orderbuddy-types'
    defineProps<CategoryOrderBuddy>()
    const { public: { cloudflareImages } } = useRuntimeConfig()
</script>
